import React from 'react'
import { initCopy } from 'locales'
import AppRouter from './router/AppRouter'
import { SsrDataProvider } from 'context/SsrDataContext'
import { HydrationBoundary } from '@tanstack/react-query'
import { HostGlobalStyles } from 'style/HostGlobalStyles'
import { GlobalProviders } from 'shared/providers/GlobalProviders'
import UnderMaintenance from 'pages/under-construction/UnderMaintenance'

// Runs here (not entry-client.jsx / entry-server.jsx individually) because
// App.jsx is the one module both the browser bundle and the Node SSR bundle
// import — a single call site covers both environments.
initCopy()

/**
 * Shared App tree for both client and server entry points.
 *
 * The entry point provides the Router (BrowserRouter in entry-client,
 * StaticRouter in entry-server) — GlobalProviders yields to it. ssrData
 * carries server-prefetched data (or window.__SSR_DATA__ on the client)
 * that components read via useSsrData().
 *
 * <title> / <meta> / <link> tags rendered anywhere in this tree are hoisted
 * into <head> by React 19 natively. No react-helmet-async needed.
 */
export const App = ({ ssrData = {} }) => {
  const maintenanceMode = import.meta.env.VITE_MAINTENANCE_MODE === 'true'

  if (maintenanceMode) {
    return <UnderMaintenance />
  }
  return (
    <GlobalProviders>
      <SsrDataProvider value={ssrData}>
        {/* Routes that prefetch server-side ship a dehydrated cache; every other
            route passes undefined, which is a no-op. Must sit inside
            GlobalProviders so it hydrates that request's QueryClient. */}
        <HydrationBoundary
          state={ssrData?.stoDetails?.dehydratedState ?? ssrData?.featuredVenture?.dehydratedState ?? undefined}>
          <HostGlobalStyles />
          <AppRouter />
        </HydrationBoundary>
      </SsrDataProvider>
    </GlobalProviders>
  )
}

export default App
